import { useState } from "react";
import { useTranslation } from "react-i18next";

function PostCard({ post, highlight }) {
  const { t } = useTranslation();
  const [playing, setPlaying] = useState(false);
  const image = post.video?.thumbnail_url || post.image_url || post.preview?.image || "";
  const site = post.preview?.site_name || "";
  return (
    <article className={`pingflo-post${highlight ? " is-pinned" : ""}`}>
      {post.video && playing ? (
        <div className="pingflo-post-video">
          <iframe
            src={`${post.video.embed_url}?autoplay=1`}
            title={post.title}
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : image ? (
        post.video ? (
          <button
            type="button"
            className="pingflo-post-media"
            onClick={() => setPlaying(true)}
            aria-label={t("newsletterWatch", "Watch the video")}
          >
            <img src={image} alt="" loading="lazy" />
            <span className="pingflo-post-play" aria-hidden="true">
              ▶
            </span>
          </button>
        ) : (
          <img className="pingflo-post-image" src={image} alt="" loading="lazy" />
        )
      ) : null}
      <h3>{post.title}</h3>
      {post.body ? <p className="pingflo-post-body">{post.body}</p> : null}
      {!post.body && post.preview?.description ? (
        <p className="pingflo-quiet">{post.preview.description}</p>
      ) : null}
      {post.url ? (
        <a href={post.url} target="_blank" rel="noopener noreferrer">
          {post.video ? t("newsletterWatch", "Watch the video") : t("newsletterReadMore", "Read more")}
          {site ? ` · ${site}` : ""}
        </a>
      ) : null}
      {post.author_name ? <p className="pingflo-post-author">{post.author_name}</p> : null}
    </article>
  );
}

export function NewsletterPosts({ posts, title, highlight = false }) {
  if (!posts?.length) return null;
  return (
    <section className="pingflo-section">
      <h2>{title}</h2>
      {posts.map((post) => (
        <PostCard key={post.post_id} post={post} highlight={highlight} />
      ))}
    </section>
  );
}
